import { getLocale } from "@/data/regionInfo";
import undo from '@/mixins/Customizer/Undo';

export default {
  mixins: [undo],
  computed: {
    modelName() {
      return this.$store.state.transferDesign.modelName;
    },
    showSpinner() {
      return this.isLoadingData || this.step === 'transfer-style';
    },
    translations(){
      return this.$store.state.translations.data;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  watch: {
    ['$store.state.utils.isDesignTransfering'](isTransfering) {
      if (!isTransfering) {
        this.$modal.hide(this.configuration.modals?.transferDesign ? 'transferDesignModal' : 'transferDesignComponent');
        this.checkPersonalization();
      }
    },
    showSpinner(show) {
      this.$refs.spinner && this.$refs.spinner.hideSpinner(!show);
    },
  },
  methods: {
    initModal() {
      if (this.modelName) {
        this.$store.commit('transferDesign/CLEAN_DESIGN_DATA');
      }

      this.showCtaPrimaryButton(true);
      this.blockCtaPrimaryButton(true);
      return this.loadRecipes();
    },
    loadRecipes() {
      const currentRecipe = this.$store.state.recipe.recipe_v2;
      const previousRecipe = this.$store.state.transferDesign.originalRecipe;
      // checks if the recipe is the same and uses the cached results from the Vuex store
      if (JSON.stringify(currentRecipe) === JSON.stringify(previousRecipe)) {
        this.isLoadingData = false;
        return;
      }
      this.isLoadingData = true;
      this.loadExternal3dViewer=false;
      return this.$store
        .dispatch('transferDesign/FETCH_RECIPES', { recipe: currentRecipe } )
        .then(recipes => {
          this.$store.commit('transferDesign/SET_ORIGINAL_RECIPE', currentRecipe);
          this.$store.commit('transferDesign/SET_RECIPES', recipes);
          const promises = [];
          const recipesArray = Object.keys(recipes);
          // push the requests for images
          if(!this.$store.state.utils.configuration.enableSnapshotService) {
            promises.push(...recipesArray.map(modelName => {
              return this.getProductImage(recipes[modelName].recipe_v2)
                .then(imageUrl => this.imageUrls[modelName] = imageUrl);
            }));
          }
          // push the requests for prices
          promises.push(...recipesArray.map(modelName => {
            return this.getProductPrice(recipes[modelName].recipe_v2)
              .then(({ priceInString }) => this.prices[modelName] = priceInString);
          }));
          return Promise.all(promises)
            .then(() => {
              this.$store.commit('transferDesign/SET_IMAGE_URLS', this.imageUrls);
              this.$store.commit('transferDesign/SET_PRICES', this.prices);
              if(!this.$store.state.utils.configuration.enableSnapshotService) this.isLoadingData = false;
              else this.loadExternal3dViewer=true;
            })
            .catch(error => console.error("Error loading images and recipes for transfer design modal", error));
        });
    },
    goToTransferStyleStep() {
      this.step = "transfer-style";
    },
    closeAction() {
      this.$modal.hide('transferDesignModal');
      this.onClose();
    },
    onClose() {
      this.step = "choose-style";
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerTransferDesign,
        eventLabel: `Close Modal`,
        forceEcomDataLayerFormat: true,
      });
      this.checkNeedReposition();
    },
    getProductImage(recipe) {
     const featuredView =
      this.$store.state.utils.pdm.product_images.featured_views?.change_style
      ??  { view: "checkerboard_creator", size: "md" };
      return this.$store
        .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE", {
          recipe: recipe,
          locale: getLocale(),
          type: 'customizer',
          ...featuredView
        })
        .then(data => {
          return data[`${featuredView.view}_view`][featuredView.size];
        });
    },
    getProductPrice(recipe_v2) {
      return this.$store.dispatch("transferDesign/FETCH_PRICE", recipe_v2);
    },
    checkPersonalization() {
      if (this.$store.state.transferDesign.isPersonalizationInvalid) {
        const componentName = this.$store.getters['personalization/getPersonalizationComponentName'];
        this.cleanPreviousEmbroidery(this.recipe_v2.components[componentName].personalization);
        this.$personalization.removePersonalization();

        const personalizationComponent = this.$store.getters['personalization/getPersonalizationComponentName']
        const recipePersonalizationComponent = this.$store.state.recipe.recipe_v2.components[personalizationComponent];

        this.$store.commit('personalization/SET_CHANGE_STYLE_FLOW', true);

        if (recipePersonalizationComponent.hasOwnProperty('personalization')) {
          delete recipePersonalizationComponent['personalization'];
        }

        if (this.configuration.modals?.embroidery) {
          this.$modal.show('embroideryModal');
        } else {
          this.$modal.show('newEmbroideryModal');
        }
      }
    },
    checkNeedReposition() {
      if (this.$store.state.transferDesign.recipes?.[this.modelName]?.need_reposition) {
        this.$eventBus.$emit('edit-ugc');
      }
    }
  },
  created() {
    this.step = "choose-style";
  }
}